import { render, staticRenderFns } from "./FormAmend.vue?vue&type=template&id=74d0ffcc&"
import script from "./FormAmend.vue?vue&type=script&lang=js&"
export * from "./FormAmend.vue?vue&type=script&lang=js&"
import style0 from "./FormAmend.vue?vue&type=style&index=0&id=74d0ffcc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports